import { render, staticRenderFns } from "./VolDotsReported.vue?vue&type=template&id=51d84b78"
import script from "./VolDotsReported.vue?vue&type=script&lang=js"
export * from "./VolDotsReported.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports